module.exports = __webpack_public_path__ + "static/media/tj.f32869ea.svg";